// tslint:disable: max-line-length
import { findGTZOrt } from './findGTZOrt';
import { WFormData } from '../../../core/forms/WFormData';

export async function getWetterstation(
    data: any, lastAdressString: string, formData: WFormData, onValueChange: (name: string, value: any) => void
): Promise <string> {
    console.log('getWetterstation: Last Addr: ',lastAdressString);
    const MAPBOX_TOKEN = 'pk.eyJ1Ijoib2xpdmVyYnVuZGEiLCJhIjoiY2s1bWt2djVzMHhvOTNucGNzZXhrdWFuOSJ9.msxL5i1GigS33y-i3OtYMQ';
        const values = formData.getAllValues();
        const plz = values.plz || '';
        const ort_gtz = values.ort_gtz || '';
        const adressString = plz;
        console.log('getWetterstation:Addr: ',plz);
        let country = 'DE';
        if((plz+'').length == 4) {  // DIRTY
            country = 'LU';
        }
        // const adressString = `${values.strasse || ''} ${values.hausnummer || ''} ${plz}`;
        const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(adressString)}.json?country=${country}&limit=5&language=de&access_token=${MAPBOX_TOKEN}`;
        console.log('getWetterstation: URL: ', url);
        const lastSaveAdress: Promise<string> = (plz && (plz.length === 5 || plz.length == 4 /* DIRTY */) && (adressString !== lastAdressString || !ort_gtz.length))
            ? await fetch(url)
                .then(response => response.json())
                .then(json => {
                    console.log('Checking for match ...');
                    if (json.features && json.features[0] && json.features[0].center) {
                        console.log('getWetterstation Map-Res:', json.features[0].center);
                        const lon = json.features[0].center[0];
                        const lat = json.features[0].center[1];
                        console.log('getWetterstation: GPS: ', lat, lon);
                        const ortFound = findGTZOrt(data, lat, lon, true);
                        if (ortFound && ortFound.ort !== ort_gtz) {
                            console.log('GTZ-ORT-MATCH: ', lat, lon, ortFound, ort_gtz);
                            if (ort_gtz !== ortFound.ort) {
                                // Ein Vergleich ist erforderlich, um das Auto-Speichern nicht immer wieder zu triggern.
                                onValueChange('ort_gtz', ortFound.ort);
                            }
                        }
                        return adressString;
                    } else {
                        return lastAdressString;
                    }
                })
            : lastAdressString;
            // console.log('URL-MA)PBOX: ' + url);
    return lastSaveAdress;
}
